import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "format", "prizeDeliverySection", "deliveryMechanismField", "inAppDeliverySetting", "inAppDeliveryFileUploadField", "inAppDeliveryDigitalAcceptedFileTypes", "inAppDeliveryAudioAcceptedFileTypes", "fileInput", "progressBar", "progressFill"]

  connect() {
    if (this.formatTarget) {
      this.setFileAcceptAttribute();
      const format = this.formatTarget.value;
      if (format === 'digital' || format === 'audio') {
        this.prizeDeliverySectionTarget.classList.remove('hidden');
        this.inAppDeliverySettingTarget.classList.remove('hidden');
      }
    }

    this.element.addEventListener('direct-upload:initialize', this.uploadInitialize.bind(this))
    this.element.addEventListener('direct-upload:progress', this.uploadProgress.bind(this))
    this.element.addEventListener('direct-upload:end', this.uploadEnd.bind(this))
  }

  toggleDeliveryOptions() {
    const format = this.formatTarget.value;

    this.hideAllDeliveryOptions();

    if (format === 'print') {
      this.prizeDeliverySectionTarget.classList.remove('hidden');
      this.deliveryMechanismFieldTarget.classList.remove('hidden');
    } else if (format === 'digital' || format === 'audio') {
      this.prizeDeliverySectionTarget.classList.remove('hidden');
      this.inAppDeliverySettingTarget.classList.remove('hidden');
      const inAppDeliveryYesOption = this.inAppDeliverySettingTarget.querySelector('input[type=radio][value=true]');
      inAppDeliveryYesOption.checked = true;
      this.inAppDeliveryFileUploadFieldTarget.classList.remove('hidden');
      if (format === 'digital') {
        this.inAppDeliveryDigitalAcceptedFileTypesTarget.classList.remove('hidden');
      } else {
        this.inAppDeliveryAudioAcceptedFileTypesTarget.classList.remove('hidden');
      }
      this.setFileAcceptAttribute();
    }
  }

  hideAllDeliveryOptions() {
    this.prizeDeliverySectionTarget.classList.add('hidden');
    this.deliveryMechanismFieldTarget.classList.add('hidden');
    this.inAppDeliverySettingTarget.classList.add('hidden');
    this.inAppDeliveryFileUploadFieldTarget.classList.add('hidden');
    this.inAppDeliveryDigitalAcceptedFileTypesTarget.classList.add('hidden');
    this.inAppDeliveryAudioAcceptedFileTypesTarget.classList.add('hidden');
  }

  toggleInAppDeliveryOptions(event) {
    const selectedValue = event.target.value;
    const format = this.formatTarget.value;

    if (selectedValue === 'false') {
      this.inAppDeliveryFileUploadFieldTarget.classList.add('hidden');
      this.inAppDeliveryDigitalAcceptedFileTypesTarget.classList.add('hidden');
      this.inAppDeliveryAudioAcceptedFileTypesTarget.classList.add('hidden');
      this.deliveryMechanismFieldTarget.classList.remove('hidden');
    } else {
      this.inAppDeliveryFileUploadFieldTarget.classList.remove('hidden');
      if (format === 'digital') {
        this.inAppDeliveryDigitalAcceptedFileTypesTarget.classList.remove('hidden');
      } else {
        this.inAppDeliveryAudioAcceptedFileTypesTarget.classList.remove('hidden');
      }
      this.deliveryMechanismFieldTarget.classList.add('hidden');
    }
  }

  setFileAcceptAttribute() {
    const format = this.formatTarget.value;
    const fileInput = this.fileInputTarget;

    let accept;
    switch(format) {
      case 'digital':
        accept = ".pdf,.epub,.azw,.zip";
        break;
      case 'audio':
        accept = ".mp3,.aac,.wav,.m4a,.m4b,.zip";
        break;
      default:
        accept = "";
        break;
    }
    fileInput.setAttribute("accept", accept);
  }

  uploadInitialize(event) {
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.classList.remove('hidden')
      this.progressFillTarget.style.width = '0%'
    }
    const btn = this.formTarget.querySelector('button')
    if (btn) {
      const enabledSpan = btn.querySelector('.show-when-enabled')
      if (enabledSpan) enabledSpan.textContent = 'Uploading prize... 0%'
    }
  }

  uploadProgress(event) {
    if (this.hasProgressFillTarget) {
      const progress = Math.round(event.detail.progress)
      this.progressFillTarget.style.width = `${progress}%`
    }
    const btn = this.formTarget.querySelector('button')
    if (btn) {
      const enabledSpan = btn.querySelector('.show-when-enabled')
      if (enabledSpan) enabledSpan.textContent = `Uploading prize... ${Math.round(event.detail.progress)}%`
    }
  }

  uploadEnd(event) {
    if (this.hasProgressFillTarget) {
      this.progressFillTarget.style.width = '100%'
    }
    const btn = this.formTarget.querySelector('button')
    if (btn) {
      const enabledSpan = btn.querySelector('.show-when-enabled')
      if (enabledSpan) enabledSpan.textContent = 'Upload complete'
    }
  }

  submitForm() {
  }
}
